import React from 'react'
import './copyright.css'

function Copyright() {
    return (
        <>
            <div className='copyrightDiv'>
                <h4 className='copyright'><i class="fa-regular fa-copyright"></i> 2023 Rohit</h4>
            </div>
        </>
    )
}

export default Copyright